import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "ml-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {useI18n} from "vue-i18n";
import {toRef} from "vue";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientDetailsPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const props = __props
const popupData = toRef(props, 'data');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_unref(t)("recipient.tabs.recipient.popups.details.name")) + ": ", 1),
    _createElementVNode("span", _hoisted_1, _toDisplayString(popupData.value.displayName), 1),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.recipient.popups.details.email")) + ": ", 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(popupData.value.email), 1),
    _hoisted_4,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.recipient.popups.details.creator")) + ": ", 1),
    _createElementVNode("span", _hoisted_5, _toDisplayString(popupData.value.owner.displayName), 1),
    _hoisted_6,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.recipient.popups.details.created")) + ": ", 1),
    _createElementVNode("span", _hoisted_7, _toDisplayString(popupData.value.createdAt ? _unref(DateToStringHelper)(new Date(popupData.value.createdAt)) : ""), 1),
    _hoisted_8,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.recipient.popups.details.changed")) + ": ", 1),
    _createElementVNode("span", _hoisted_9, _toDisplayString(popupData.value.modifiedAt ? _unref(DateToStringHelper)(new Date(popupData.value.modifiedAt)) : ""), 1),
    _hoisted_10,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.recipient.popups.details.activeTickets")) + ": ", 1),
    _createElementVNode("span", _hoisted_11, _toDisplayString(popupData.value.activeTicketCount), 1),
    _hoisted_12,
    _createTextVNode(" " + _toDisplayString(_unref(t)("recipient.tabs.recipient.popups.details.totalTickets")) + ": ", 1),
    _createElementVNode("span", _hoisted_13, _toDisplayString(popupData.value.totalTicketCount), 1),
    _hoisted_14,
    _hoisted_15,
    _createElementVNode("div", null, _toDisplayString(_unref(t)("recipient.tabs.recipient.popups.details.listPreview")) + ":", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popupData.value.recipientlistPreview, (list) => {
      return (_openBlock(), _createElementBlock("div", {
        key: list.recipientlistID,
        class: "ml-2"
      }, _toDisplayString(list.name) + " (" + _toDisplayString(list.recipientCount) + " " + _toDisplayString(_unref(t)("general.entities.recipient")) + ") ", 1))
    }), 128))
  ]))
}
}

})